import { useMutation } from 'react-query'
import API from '.'

export const usePostTrack = (config = {}) =>
  useMutation(
    ({ event = '', props = {} }) => API.post('/api/analytics', { event, props }).catch(() => {}),
    config
  )
